import React from 'react';

import Lozenge from '@atlaskit/lozenge';
import type { ThemeAppearance } from '@atlaskit/lozenge';

import { IssueStatussWrapperStyled, Spacing } from './IssueStatus.styled';

type Props = {
  children: React.ReactNode;
  kind: ThemeAppearance;
  spacing?: Spacing;
};

export default function IssueStatus({
  children,
  kind,
  spacing,
}: Props): JSX.Element {
  return (
    <IssueStatussWrapperStyled spacing={spacing}>
      <Lozenge appearance={kind}>{children}</Lozenge>
    </IssueStatussWrapperStyled>
  );
}
